module.exports = __webpack_public_path__ + "img/good.cf97f400.svg";